import { render } from "./DetailsCard.vue?vue&type=template&id=30e66aea&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"

import "./DetailsCard.vue?vue&type=style&index=0&id=30e66aea&lang=scss&scoped=true"
import "./DetailsCard.vue?vue&type=style&index=1&id=30e66aea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e66aea"]])

export default __exports__